import { Platform } from 'react-native';

/**
 * @deprecated Use `src/design-system/tokens.ts` instead.
 * This file is kept for backward compatibility during migration.
 * New code should import from `@/design-system` or `../design-system/tokens`.
 */

// Colors
export const colors = {
  primary: '#6200EE',
  primaryDark: '#3700B3',
  primaryLight: '#BB86FC',
  secondary: '#03DAC6',
  secondaryDark: '#018786',
  background: '#FFFFFF',
  surface: '#FFFFFF',
  error: '#B00020',
  onPrimary: '#FFFFFF',
  onSecondary: '#000000',
  onBackground: '#000000',
  onSurface: '#000000',
  onError: '#FFFFFF',
  text: '#000000',
  textSecondary: '#757575',
  border: '#E0E0E0',
  success: '#4CAF50',
  warning: '#FFC107',
  info: '#2196F3',
  disabled: '#BDBDBD',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent'
};

// Spacing
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48
};

// Typography
export const typography = {
  h1: {
    fontSize: 32,
    fontWeight: 'bold' as const,
    lineHeight: 40
  },
  h2: {
    fontSize: 28,
    fontWeight: 'bold' as const,
    lineHeight: 36
  },
  h3: {
    fontSize: 24,
    fontWeight: 'bold' as const,
    lineHeight: 32
  },
  h4: {
    fontSize: 20,
    fontWeight: 'bold' as const,
    lineHeight: 28
  },
  h5: {
    fontSize: 18,
    fontWeight: 'bold' as const,
    lineHeight: 24
  },
  h6: {
    fontSize: 16,
    fontWeight: 'bold' as const,
    lineHeight: 22
  },
  body1: {
    fontSize: 16,
    lineHeight: 24
  },
  body2: {
    fontSize: 14,
    lineHeight: 20
  },
  caption: {
    fontSize: 12,
    lineHeight: 16
  },
  button: {
    fontSize: 16,
    fontWeight: 'bold' as const,
    textTransform: 'uppercase' as const
  }
};

// Border radius
export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24,
  round: 100
};

// Shadows
export const shadows = {
  sm: Platform.select({
    ios: {
      
      
      
      
    },
    android: {
      // shadowColor for Android elevation tint
    },
    web: {
      boxShadow: '0px 1px 1.0px rgba(0,0,0,0.18)'
    } as any, // Cast to any for web to avoid type errors with React Native style types
  }),
  md: Platform.select({
    ios: {
      
      
      
      
    },
    android: {
      },
    web: {
      boxShadow: '0px 2px 2.62px rgba(0,0,0,0.23)'
    } as any
  }),
  lg: Platform.select({
    ios: {
      
      
      
      
    },
    android: {
      },
    web: {
      boxShadow: '0px 4px 4.65px rgba(0,0,0,0.30)'
    } as any
  })
};

// Animation
export const animation = {
  fast: 200,
  medium: 350,
  slow: 500
};

// Z-index
export const zIndex = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070
};

export default {
  colors,
  spacing,
  typography,
  borderRadius,
  shadows,
  animation,
  zIndex
};
